import { formatNumber } from 'shared/lib/formatters';

export const formatCreditCardTitle = (amount?: string, defaultValue?: string) => {
  return amount ? `${formatNumber(Number(amount))} ₽` : defaultValue || '';
};
